import type { ActivityOption } from '@/data/activities'

interface ActivityRowProps {
  option: ActivityOption
  selected: boolean
  onSelect: () => void
}

/**
 * Full-width radio row for the Activity screen. Same shape as HeightRow
 * (radio dot + label + sub-text) so the quiz reads as one consistent
 * single-select pattern across screens 1 and 4.
 */
export function ActivityRow({ option, selected, onSelect }: ActivityRowProps) {
  return (
    <button
      type="button"
      role="radio"
      aria-checked={selected}
      className={`fq-height-row${selected ? ' is-selected' : ''}`}
      onClick={onSelect}
    >
      <span className="fq-radio-dot" aria-hidden="true" />
      <span className="fq-height-body">
        <span className="fq-height-label">{option.label}</span>
        <span className="fq-height-sub">{option.blurb}</span>
      </span>
    </button>
  )
}
